import { render, staticRenderFns } from "./brigad_ajiliin_zar_details.vue?vue&type=template&id=4585a3d4&scoped=true&"
import script from "./brigad_ajiliin_zar_details.vue?vue&type=script&lang=js&"
export * from "./brigad_ajiliin_zar_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585a3d4",
  null
  
)

export default component.exports